import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { medicationsClassificationActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchMedicationsClassification, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchMedicationsClassification({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchMedicationsClassification } = this.props
    fetchMedicationsClassification()
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchMedicationsClassification, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchMedicationsClassification, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = medicationClassification => {
    const {
      fetchMedicationClassification,
      deleteMedicationClassification,
      addConfirm,
      token,
      restoreMedicationClassification
    } = this.props

    return (
      <Fragment>
        {readOnly('cla', token) &&
          !medicationClassification.deletedAt && (
            <IconButton
              onClick={() => {
                fetchMedicationClassification(medicationClassification._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!medicationClassification.deletedAt &&
        findPermission('classificacoes_medicamentos', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração desta classificação?',
                confirmFunction: () => {
                  restoreMedicationClassification(medicationClassification._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('classificacoes_medicamentos', token).editar && (
              <IconButton
                onClick={() => {
                  fetchMedicationClassification(medicationClassification._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('classificacoes_medicamentos', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão desta classificação?',
                    confirmFunction: () => {
                      deleteMedicationClassification(medicationClassification._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const {
      classes,
      medicationsClassification = [],
      loadingMedicationsClassification,
      pagination,
      order = {}
    } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingMedicationsClassification && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
          width={'990px'}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Classificações dos Medicamentos
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {(medicationsClassification || []).length ? (
              (medicationsClassification || []).map(medicationClassification => {
                return (
                  <TableRow key={medicationClassification._id}>
                    <TableRowColumn>{medicationClassification.nome}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(medicationClassification)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingMedicationsClassification ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    medicationClassification: state.medicationClassification.medicationClassification,
    medicationsClassification: state.medicationClassification.medicationsClassification,
    loadingMedicationsClassification:
      state.medicationClassification.loadingMedicationsClassification,
    token: state.auth.token,
    pagination: state.medicationClassification.medicationsClassificationPagination,
    order: state.medicationClassification.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(medicationsClassificationActions.openModal())
    },
    closeModal: () => {
      dispatch(medicationsClassificationActions.closeModal())
    },
    fetchMedicationClassification: id => {
      dispatch(medicationsClassificationActions.fetchMedicationClassification(id))
    },
    fetchMedicationsClassification: options => {
      dispatch(medicationsClassificationActions.fetchMedicationsClassification(options))
    },
    deleteMedicationClassification: id => {
      dispatch(medicationsClassificationActions.deleteMedicationClassification(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(medicationsClassificationActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(medicationsClassificationActions.handleChangePerPage(perPage))
    },
    restoreMedicationClassification: id => {
      dispatch(medicationsClassificationActions.restoreMedicationClassification(id))
    },
    changeOrderColumn: column => {
      dispatch(medicationsClassificationActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(medicationsClassificationActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/MedicationClassification/ListTable.js